import styled from 'styled-components'
import { Tooltip as OTooltip } from '@chegg-ui/tooltip'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { BodyLargeGray } from '@chegg-wt/core/theme/sunkist/typography'

export const SortContainer = styled.div`
  display: flex;
  position: relative;
`

export const SortByText = styled.span`
  ${BodyLargeGray};
`

export const Sort = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: ${values.xsmall};
  }
`

export const DropdownContainer = styled.div``

export const Tooltip = styled(OTooltip)`
  align-self: flex-end;
`

export const TooltipText = styled.span`
  text-align: center;
`
